export const MODERATIONS_ACTIONS = {
  MODERATIONS_REQUEST: "MODERATIONS_REQUEST",
  MODERATIONS_RESPONSE: "MODERATIONS_RESPONSE",
  MODERATIONS_ERROR: "MODERATIONS_ERROR",
};

export const MODERATIONS_INACTIVATE_ACTIONS = {
  MODERATIONS_INACTIVATE_REQUEST: "MODERATIONS_INACTIVATE_REQUEST",
  MODERATIONS_INACTIVATE_RESPONSE: "MODERATIONS_INACTIVATE_RESPONSE",
  MODERATIONS_INACTIVATE_ERROR: "MODERATIONS_INACTIVATE_ERROR",
};

export const MODERATIONS_GET_REPORTS_BY_ID_ACTIONS = {
  MODERATIONS_GET_REPORTS_BY_ID_REQUEST: "MODERATIONS_GET_REPORTS_BY_ID_REQUEST",
  MODERATIONS_GET_REPORTS_BY_ID_RESPONSE: "MODERATIONS_GET_REPORTS_BY_ID_RESPONSE",
  MODERATIONS_GET_REPORTS_BY_ID_ERROR: "MODERATIONS_GET_REPORTS_BY_ID_ERROR",
};


export const MODERATIONS_CREATE_UPDATE_ACTIONS = {
  MODERATIONS_CREATE_UPDATE_REQUEST: "MODERATIONS_CREATE_UPDATE_REQUEST",
  MODERATIONS_CREATE_UPDATE_RESPONSE: "MODERATIONS_CREATE_UPDATE_RESPONSE",
  MODERATIONS_CREATE_UPDATE_ERROR: "MODERATIONS_CREATE_UPDATE_ERROR",
};

export const MODERATIONS_DELETE_ACTIONS = {
  MODERATIONS_DELETE_REQUEST: "MODERATIONS_DELETE_REQUEST",
  MODERATIONS_DELETE_RESPONSE: "MODERATIONS_DELETE_RESPONSE",
  MODERATIONS_DELETE_ERROR: "MODERATIONS_DELETE_ERROR",
};
